module.exports = __webpack_public_path__ + "img/sirkel_realisme.ff87dfa1.png";